import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateObjectRelationsComponent } from './create-object-relations.component';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { NgxMatSelectSearchShimModule } from '@app/shims/mat-select-search/ngx-mat-select-search.shim';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { FuseCardComponent } from '@fuse/components/card';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightModule } from '@app/shared/modules/ng-option-highlight.module';
import { CreateNewTagModule } from '../create-new-tag/create-new-tag.module';

@NgModule({
    declarations: [CreateObjectRelationsComponent],
    imports: [
        CommonModule,

        ReactiveFormsModule,

        FormsModule,

        RouterModule,

        TranslateModule.forChild(),

        NgxMatSelectSearchShimModule,

        NgSelectModule,
        NgOptionHighlightModule,

        UiSwitchModule,
        FuseCardComponent,

        FontAwesomeModule,

        MaterialModule,

        SharedModule,

        CreateNewTagModule
    ],
    exports: [CreateObjectRelationsComponent]
})
export class CreateObjectRelationsModule { }
